import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { numberOfCurrentLeadersDisplayed } from "../helper/SalHelpers";
import CaptionTable from "components/general/table/CaptionTable";
import Label from "components/general/Label";
import { useMemo } from "react";
import { CurrentLeadersColumns } from "./Columns";
import useViewport from "components/general/useViewPort";
import MirsTable from "components/general/table/Table";
import { isStartListStatus } from "helpers/status";
import { getLongEventRSC } from "helpers/rsc";
import { Table } from "react-bootstrap";
import 'styles/sports/sal.scss';

const SalCurrentLeaders = ({ data, statusData }) => {
    const { mirs_rsc } = useUrlFriendlyToParameters();
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs"

    const totalLeaders = numberOfCurrentLeadersDisplayed(data?.results?.eventUnitCode)
    const leadersData = data.results.items?.filter(i => i.extendedResultsCurrent)?.sort((a, b) => a?.sortOrder - b?.sortOrder)?.filter((i, index) => index < totalLeaders)

    const status = statusData?.results?.currentExtendedInfos?.find(i => i?.ei_value === getLongEventRSC(mirs_rsc));
    const currentForCaption = status?.extensions?.find(i => i?.eie_code === 'LEG_CURRENT')?.eie_value;
    const captionText = currentForCaption ? <> - {currentForCaption}</> : <></>
    const caption = (<CaptionTable leftCol={<span className="fw-bold"><Label data="HeaderCurrentLeaders" />{captionText}</span>} />);

    const type = data?.results?.items?.length > 0 ? data?.results?.items[0]?.itemType : ''; // Team or Athlete
    let currentLeg = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'LEG_CURRENT')?.ei_value;
    const isLeg1 = currentLeg === '1' || isStartListStatus(data?.results?.status?.code);
    const raceColumns = useMemo(() => CurrentLeadersColumns(type, isLeg1), [isLeg1]);

    if (!leadersData || leadersData?.length === 0) return <></>;

    const getHiddenColumns = () => {
        const mobileHidden = isMobile ? [] : []
        return [...mobileHidden];
    }

    const windDirection = status?.extensions?.find(i => i?.eie_code === 'WIND_DIR')?.eie_value;
    const windSpeed = status?.extensions?.find(i => i?.eie_code === 'WIND_SPEED')?.eie_value;

    const mainTable = (
        <MirsTable
            id={`mirs-table-curremt-results-${mirs_rsc}`}
            caption={caption}
            data={leadersData}
            columns={raceColumns}
            keyRow={"participant-code"}
            initialSortBy={[{ id: 'Rank', desc: false }]}
            hiddenColumns={getHiddenColumns()}
        />
    );

    const windTable = (<Wind direction={windDirection} speed={windSpeed} />);

    const xl = (
        <div className="container mt-2">
            <div className="row">
                <div className="w-80">
                    {mainTable}
                </div>
                <div className="w-20 windtable">
                    {windTable}
                </div>
            </div>
        </div>
    );


    const xs = (
        <div className="container mt-2">
            <div className="row">
                <div className="w-100">
                    {mainTable}
                </div>
            </div>
        </div>
    );

    return (isMobile ? xs : xl);
}

export default SalCurrentLeaders;

const Wind = ({ direction, speed }) => {
    return (
        <Table striped>
            <thead>
                <tr><td className="fw-bold"><Label data='HeaderWind' /></td></tr>
            </thead>
            <tbody>
                <tr><td><Label data='HeaderDirection' />: {direction}</td></tr>
                <tr><td>&nbsp;</td></tr>
                <tr><td><Label data='HeaderSpeed' />: {speed}</td></tr>
                <tr><td>&nbsp;</td></tr>
            </tbody>
        </Table>
    );
}